import type { TOC } from '@ember/component/template-only';

import ClientsTableComponent from 'webapp/components/clients/table';
import NoResultsClientsComponent from 'webapp/components/no-results/clients';
import type ClientsAccountsController from 'webapp/controllers/clients/accounts';

interface Args {
	controller: ClientsAccountsController;
}

const ClientsAccountsRouteTemplate: TOC<Args> = <template>
	{{#if @controller.clients}}

		<div id="clients-list" class="view-table">
			<ClientsTableComponent
				@model={{@controller.clients}}
				@onAdd={{@controller.createNewClient}}
				@onDelete={{@controller.deleteClient}}
			/>
		</div>

	{{else}}

		<NoResultsClientsComponent @onCreate={{@controller.createNewClient}} />

	{{/if}}
</template>;

export default ClientsAccountsRouteTemplate;
